export class InvoiceSettings {
	constructor(data = {}) {
		this.companyName = data.companyName || '';
		this.country = data.country || '';
		this.city = data.city || '';
		this.address = data.address || '';
		this.taxNumber = data.taxNumber || '';
		this.companyRegistrationNumber = data.companyRegistrationNumber || '';
		this.companyRegistrationExpiryDate = data.companyRegistrationExpiryDate || null;
		
		this.autoGenerateInvoices = data.autoGenerateInvoices ?? false;
		
		this.invoiceNumbering = {
			prefix: data.invoiceNumbering?.prefix || 'INV',
			charsCount: data.invoiceNumbering?.charsCount || 6,
			startNumber: data.invoiceNumbering?.startNumber || 1,
			...data.invoiceNumbering
		};
		
		this.returnInvoiceNumbering = {
			prefix: data.returnInvoiceNumbering?.prefix || 'RET',
			charsCount: data.returnInvoiceNumbering?.charsCount || 6,
			startNumber: data.returnInvoiceNumbering?.startNumber || 1,
			...data.returnInvoiceNumbering
		};

		this.logo = data.logo || null;
	}

	toFirestore() {
		return {
			companyName: this.companyName,
			country: this.country,
			city: this.city,
			address: this.address,
			taxNumber: this.taxNumber,
			companyRegistrationNumber: this.companyRegistrationNumber,
			companyRegistrationExpiryDate: this.companyRegistrationExpiryDate,
			autoGenerateInvoices: this.autoGenerateInvoices,
			invoiceNumbering: this.invoiceNumbering,
			returnInvoiceNumbering: this.returnInvoiceNumbering,
			logo: this.logo,
			updatedAt: new Date().toISOString(),
		};
	}
}
